(ns guidebook.views.risk-profile
  (:require
   [guidebook.common :as gc :refer [format-date]]
   [util.core :refer [valid-date?]]
   [very.re-frame.core :as rf]
   [cljss.core :as cljss]
   [css.vars :as vars]
   [css.core
    :refer [get-theme]
    :refer-macros [defstyled]]))

(defstyled risk-table-s :div
  {::cljss/media {[:print]
                  {:margin-top "100px"}}})

(defstyled risk-row-s :div
  {:display "grid"
   :grid-template-columns "1fr 1fr 1fr"
   :text-align "center"})

(defstyled risk-header-s :div
  {:font-size "24px"
   :color vars/gray
   :margin "0 -2px 0 0"
   :padding "2rem 0 1.25rem"
   :display "flex"
   :align-items "center"
   :border-right (str "2px dashed " vars/border-light)
   :justify-content "center"
   :&:last-child {:border-right "none"
                  :margin-right "none"}})

(defstyled cell-s :div
  {:padding "0 20px 30px"
   :margin "3px -2px 0 0"
   :border-right (str "2px dashed " vars/border-light)
   :font-size "24px"
   :font-weight 300
   :&:last-child {:border-right "none"
                  :margin-right "0"}})

(defstyled cell-long-s :div
  {:padding "0 30px 20px"
   :border-right (str "2px dashed " vars/border-light)
   :font-size "15px"
   :margin "3px -2px 0 0"
   :font-weight 300
   :line-height "24px"
   :&:last-child {:border-right "none"
                  :margin-right "0"}})

(defstyled cell-comment-s :div
  {:padding "0 20px 5px"
   :justify-content "center"
   :margin "3px -2px 0 0"
   :border-right (str "2px dashed " vars/border-light)
   :font-size "12px"
   :font-weight 700
   :display "flex"
   :align-items "center"
   :color vars/gray
   :&:last-child {:border-right "none"
                  :margin-right "0"}
   ::cljss/media {[:print]
                  {:font-size "15px"
                   :line-height "24px"}}})

(defn risk-table []
  (fn [score]
    [risk-table-s
     (into [gc/score-s] (map #(gc/build-score {:current %
                                               :target score
                                               :bottom? false}) (range 1 31)))
     [gc/score-gradient-s]
     [risk-row-s
      [risk-header-s "CONSERVATIVE"]
      [risk-header-s "MODERATE"]
      [risk-header-s "GROWTH"]]
     [risk-row-s
      [cell-long-s "Accepting of lower returns for a higher degree of stability"]
      [cell-long-s "Accepting of moderate risk to seek higher long-term returns"]
      [cell-long-s "Willing to accept significant risk"]]
     [risk-row-s
      [cell-comment-s "POTENTIAL RETURN"]
      [cell-comment-s "POTENTIAL RETURN"]
      [cell-comment-s "POTENTIAL RETURN"]]
     [risk-row-s
      [cell-s "3 to 5%"]
      [cell-s "5 to 7%"]
      [cell-s "Above 7%"]]
     [risk-row-s
      [cell-comment-s "RETURN IN A 20% DOWN MARKET"]
      [cell-comment-s "RETURN IN A 20% DOWN MARKET"]
      [cell-comment-s "RETURN IN A 20% DOWN MARKET"]]
     [risk-row-s
      [cell-s "0 to -10%"]
      [cell-s "-11 to -20%"]
      [cell-s "Below -20%"]]
     [risk-row-s
      [cell-long-s "Conservative investors are willing to forego significant upside potential to eliminate large downside market fluctuations"]
      [cell-long-s "Moderate investors are willing to accept a fair amount of risk without losing a significant amount of accumulated wealth"]
      [cell-long-s "Growth investors have a longer investment time horizon and are comfortable assuming greater risk for potential higher returns"]]]))

(defstyled risk-profile-s :div
  {:display "grid"
   :padding "150px 100px"
   :grid-gap "180px"
   :grid-template-columns "500px 1fr"
   ::cljss/media {[:print]
                  {:display "flex"
                   :flex-direction "column"
                   :width "100%"
                   :padding "82px 100px"}}})

(defstyled title-s :h1
  {:font-size "94px"
   :font-weight 300
   :text-transform "uppercase"
   :margin-bottom "2rem"
   :line-height "110px"
   :color "black"
   ::cljss/media {[:print]
                  {:font-size "68px"
                   :line-height "80px"
                   :-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :margin-bottom "1rem"
                   :text-align "right"}}})

(defstyled body-s :div
  {:color "black"
   :font-size "25px"
   :font-weight 300
   :line-height "36px"
   ::cljss/media {[:print]
                  {:text-align "right"
                   :font-size "20px"
                   :line-height "32px"}}})

(defstyled box-s :div
  {::cljss/media {[:print]
                  {:width "50%"
                   :margin-left "auto"}}})

(defstyled date-s :span
  {:font-weight 700})

(defn main []
  (let [risk-profile (rf/subscribe [:guidebook/most-recent-risk-profile])]
    (fn []
      (let [updated-date (:updated-at @risk-profile)
            score (:score @risk-profile)]
        [risk-profile-s
         [box-s
          [title-s "Risk Profile"]
          [body-s
           (str "It all starts with your tolerance for risk.  We use your risk score to design your financial plan and allocat)e your money to the appropriate investments based on your personal goals.  The risk score below is calculated based on the answers you provided in your last survey"
                (if (valid-date? updated-date) " taken " "."))
           (when (valid-date? updated-date)
             [date-s (format-date updated-date)])]]
         [risk-table score]]))))
